/**
 * Matières Upcyclées - Interactive Material Selector
 * Handles hover (desktop) and click interactions for material selection
 */

class MatieresUpcyclees {
  constructor(container) {
    this.container = container;
    this.icons = container.querySelectorAll('[data-matiere-item]');
    this.selectedNameElement = container.querySelector('[data-selected-name]');
    this.isMobile = window.innerWidth < 768;

    this.init();
  }

  init() {
    if (!this.icons.length) return;

    this.icons.forEach((icon) => {
      // Click event (desktop + mobile)
      icon.addEventListener('click', (e) => {
        this.selectMatiere(icon);
      });

      // Hover event (desktop only)
      if (!this.isMobile) {
        icon.addEventListener('mouseenter', (e) => {
          this.selectMatiere(icon);
        });
      }
    });

    // Handle window resize to update mobile/desktop behavior
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
    });
  }

  selectMatiere(icon) {
    // Remove active class from all icons
    this.icons.forEach((i) => i.classList.remove('active'));

    // Add active class to selected icon
    icon.classList.add('active');

    // Update the selected material name
    const matieName = icon.dataset.matiereName;
    if (this.selectedNameElement && matieName) {
      this.selectedNameElement.textContent = matieName;
    }
  }
}

// Initialize all matières upcyclées containers on page load
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-matieres-container]');

  containers.forEach((container) => {
    // Get the parent container (m-product-matieres-upcyclees)
    const parentContainer = container.closest('.m-product-matieres-upcyclees');
    if (parentContainer) {
      new MatieresUpcyclees(parentContainer);
    }
  });
});
